/*=========================================================================================
  File Name: getters.js
  namespace: iframes
  Description: Vuex Store - IFrame getters
==========================================================================================*/
import {
  buildIFrameState
} from './state'

const getters = {
  getCurrentIFrame: state => {
    return state.currentIFrame
  },
  getNewIFrame: () => {
    return buildIFrameState()
  },
  getIFrameList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getIFrameEntries: state => {
    return state.iframeList
  },
  getCurrentIFrameFiles: state => {
    return state.currentIFrameFiles
  }
}

export default getters
